import { memo, ReactNode } from 'react';
import { IconButton, Tooltip, CircularProgress } from '@mui/material';

export interface ActionIconButtonProps {
  tooltip: string;
  icon: ReactNode;
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
  color?: 'inherit' | 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
  size?: 'small' | 'medium' | 'large';
}

/**
 * Reusable action icon button with tooltip and loading state
 */
export const ActionIconButton = memo<ActionIconButtonProps>(({
  tooltip,
  icon,
  onClick,
  disabled = false,
  loading = false,
  color = 'default',
  size = 'medium',
}) => (
  <Tooltip title={tooltip}>
    <span>
      <IconButton
        onClick={onClick}
        disabled={disabled || loading}
        color={color}
        size={size}
      >
        {loading ? <CircularProgress size={size === 'small' ? 16 : 24} /> : icon}
      </IconButton>
    </span>
  </Tooltip>
));

ActionIconButton.displayName = 'ActionIconButton';

export default ActionIconButton;
